import { StyleSheet } from "react-native-unistyles";

const stylesheet = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    _web: {
      minHeight: "90vh",
    },
  },
});

export default stylesheet;
